export enum TimelineClassesEnum {
  TimelineInterruptedClass = 'item-interrupted',
  TimelineStartedClass = 'item-active',
  TimelineStoppedClass = 'item-stopped',
  TimelineDefaultClass = 'item-pending',
}
